<nav aria-label="Progress">
    <ol role="list" class="overflow-hidden mr-3">
        @for(item of componentModel.steps.value; track $index){
            <li class="relative pb-10">
                @if($index !== componentModel.steps.value.length - 1){
                    <div class="absolute right-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300" aria-hidden="true"></div>
                }
                <!-- Current Step -->
                <a class="group relative flex items-start justify-between w-full" aria-current="step">
                    <div class="grid grid-cols-5 justify-start flex-1 gap-4 w-full">
                        @if (item?.image?.value) {
                            <div class="col-span-1">
                                <img loading="lazy" [src]="item?.image?.value" class="aspect-[14/13] object-top max-h-56 w-full rounded-2xl object-contain" [alt]="item.title.value">
                            </div>
                        }
                        <span
                                class="ml-4 flex min-w-0 flex-col pr-5"
                                [ngClass]="item?.image?.value ? 'col-span-4' : 'col-span-5'"
                        >
                            <span class="text-lg font-bold text-normal">{{item.title.value}}</span>
                            <span class="text-md text-normal">{{item.description.value}}</span>
                        </span>
                    </div>
                    <span class="flex h-9 items-center justify-end" aria-hidden="true">
                        <span class="relative text-button-primary z-10 flex size-8 items-center justify-center rounded-full border-2 border-normal bg-primary">
                            {{$index + 1}}
                        </span>
                    </span>
                </a>
            </li>
        }
    </ol>
</nav>
